import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbEllipsisAnimation } from "abreact/progress/AbEllipsisAnimation";
import * as React from "react";
import { useOnMount, useSafeTimeout } from "abreact/utils/AbHooks";

/**
 * The possible sizes for a busy indicator.
 */
export let BusyIndicatorSize = /*#__PURE__*/function (BusyIndicatorSize) {
  BusyIndicatorSize["CUSTOM"] = "custom";
  BusyIndicatorSize["TINY"] = "tiny";
  BusyIndicatorSize["SMALL"] = "small";
  BusyIndicatorSize["LARGE"] = "large";
  return BusyIndicatorSize;
}({});

/**
 * Properties of the AbBusyIndicator component.
 */

/**
 * Default number of milliseconds to wait before displaying indicator.
 * If you change this value, update the doc on {@link AbBusyIndicatorProps.delay}
 */
const DEFAULT_INITIAL_DELAY = 250;
const sizeToClassName = size => {
  switch (size) {
    case BusyIndicatorSize.CUSTOM:
      return "ab-busy-indicator-custom";
    case BusyIndicatorSize.LARGE:
      return "ab-busy-indicator-large";
    case BusyIndicatorSize.TINY:
      return "ab-busy-indicator-tiny";
    case BusyIndicatorSize.SMALL:
      return "ab-busy-indicator-small";
    case undefined:
      return "ab-busy-indicator-small";
  }
};

/**
 * The **AbBusyIndicator** component is a visual indicator used to signify that a portion of the application is busy.
 */
const AbBusyIndicator = (props, ref) => {
  const [visible, setVisible] = React.useState(props.delay === 0);
  const safeSetTimeout = useSafeTimeout();
  useOnMount(() => {
    safeSetTimeout(() => {
      setVisible(true);
    }, props.delay ?? DEFAULT_INITIAL_DELAY);
  });
  const divProps = ReactUtils.componentProps("ab-busy-indicator", props, [sizeToClassName(props.size)]);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, divProps, {
    "data-test-component": "ab-busy-indicator"
  }), /*#__PURE__*/React.createElement(AbEllipsisAnimation, {
    style: visible ? undefined : {
      clipPath: "circle(0)"
    }
  }), props.message && /*#__PURE__*/React.createElement("div", {
    className: "ab-busy-indicator-message"
  }, visible ? props.message : /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0")));
};
const WrappedAbBusyIndicator = /*#__PURE__*/React.forwardRef(AbBusyIndicator);
export { WrappedAbBusyIndicator as AbBusyIndicator };
//# sourceMappingURL=AbBusyIndicator.js.map
